import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { type FC } from 'react'

import { useTranslation } from 'services/i18n'

export const ReferencesPanelError: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation.references_panel.error',
  })

  return (
    <div className="flex flex-col items-center gap-y-3 text-balance px-32 pb-6 text-center">
      <FontAwesomeIcon icon={faCircleExclamation} className="text-danger" />
      {t('title')}
      <div className="text-subdued-on-bg-karnovnote ">
        {t('description')}
      </div>
    </div>
  )
}
